<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'lg'" :btn_cancel="true" :btn_ok="true"
  :booTitile="true">

    <div class="row d-flex mt-2 mb-4">
        <div class="input-group ">
          <input
            @change="getFile"
            type="file"
            class="form-control"
            id="file"
            lang="es"
            name="file"
            ref="fileInput"
          />
          <button type="button" class="btn btn-bm-noradius" @click="registerFile()">
            Agregar Archivos
          </button>
        </div>
    </div>

    <div class="row mx-0 mt-3">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="col-md-12 table-responsive" id="div-tabla-anular">
              <table id="tb-anular" class="table table-bordered">
                  <caption class="mx-0 px-0"></caption>
                  <thead class="bg-main" style="font-size: 13px">
                      <tr class="text-white text-center align-middle">
                        <th scope="col">N°</th>
                        <th scope="col">Fecha Subida</th>
                        <th scope="col">Acciones</th>
                      </tr>
                  </thead>
                  <tbody class="border-main" style="font-size: 12px">
                    <tr class="table-body text-center" v-if="payload.length === 0">
                        <td colspan="3" class="text-center">No hay registros</td>
                    </tr>
                    <tr v-for="(item, index) in payload" :key="index" class="text-center align-middle">
                      <template>
                        <td>{{index + 1}}</td>
                        <td>{{item.date | formatDateTime}}</td>
                        <td>
                            <a class="text-center px-2 py-2 me-2 button" href="#" @click="openFile(item.url)">
                                <i class="fas fa-file text-white"></i>
                            </a>
                            <a class="text-center px-2 py-2 button" href="#" @click="deleteFile(item.id)">
                                <i class="fas fa-trash-alt text-white"></i>
                            </a>
                        </td>
                      </template>
                    </tr>
                  </tbody>
              </table>
          </div>
      </div>
    </div>
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import moment from "moment";
import {
  mapActions
} from "vuex";

export default {
  name: "c-modal-multimedia",
  components: {
      CModal,
      SweetAlert,
  },
  data() {
      return {
        swal: null,
        data_detail: {
            url: '',
        },
      };
  },
  watch: {
  },
  props: {
      title: String,
      boo_modal: Boolean,
      id: Number,
      payload: {
        type: Array,
        required: true
      },
  },
  computed: {

  },
  methods: {
      ...mapActions(["get", "post"]),

    mtdClose() {
        this.data_detail.url = '';
        this.$emit("closeModal");
    },

    getFile(e) {
        let fileInput = this.$refs.fileInput;
        let file = e.target.files[0];
        if (
            !/\.(pdf)$/i.test(file.name) &&
            !/\.(png)$/i.test(file.name) &&
            !/\.(jpg)$/i.test(file.name) &&  !/\.(jpeg)$/i.test(file.name)
        ) {
            Swal.fire({
            text: "Seleccione un archivo formato PDF, PNG O JPG",
            icon: "info",
            confirmButtonColor: "#900052",
            });
            fileInput.value = '';
            this.data_detail.url = '';
        } else {
            this.data_detail.url = file;
        }
    },

    registerFile() {
        if (!this.data_detail.url) {
            this.$refs.SweetAlert.showWarning("Seleccionar un archivo antes de Registrar");
            return;
        }
        this.$emit('registerFile', this.data_detail, this.id);
        this.data_detail.url = '';
        let fileInput = this.$refs.fileInput;
        fileInput.value = '';
    },

    openFile(url) {
        window.open(this.$store.getters.get__url + '/assets/' + url, '_blank');
    },

    deleteFile(id) {
        this.$refs.SweetAlert.showConfirmSimple2("", "¿Estas seguro de Eliminar este Archivo?", "warning", "Eliminar")
        .then((result) => {
            if (result.value) {
                this.$emit("deleteFile", id , this.id);
            }
        });
    },

  },
  filters: {
      formatDate(date) {
          return date != null ? moment(date).format("DD/MM/YYYY") : "-";
      },
      formatDateTime(dateTime) {
          return dateTime != null ? moment(dateTime).format("DD/MM/YYYY HH:mm") : "-";
      },
  },
};
</script>
<style>
.button {
    background-color: #2f395c !important;
    border-radius: 10px !important;
    width: 15px !important;
    font-size: 12px !important;
}
</style>

